export const SET = (state, invoice) => {
  state.invoice = invoice
}
